import React, { JSX } from "react";
import {
    setMissingContractorName,
    setPostMissingContractor,
} from "../vehicleInformationSlice";
import { setGeneralStep } from "../../helpType/helpTypeSlice";
import { GeneralStepsEnum } from "../../../common/constants/GeneralStepsEnum";
import { unsetAppointment } from "../../appointment/appointmentSlice";
import { postMissingContractorName } from "../../../common/api/Dossier/postMissingContractorMail";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useParams } from "react-router-dom";

export const MissingContractor = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const { missingContractorName, postMissingContractor } = useAppSelector(
        (state) => state.vehicleInformation,
    );
    const { dossier } = useAppSelector((state) => state.root);
    const { slug } = useParams();

    const handleMissingContractorNameChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        dispatch(setMissingContractorName(event.target.value));
        dispatch(setPostMissingContractor(false));
    };

    const handleMissingContractorSubmit = (): void => {
        if (postMissingContractor || isSubmitting) return;
        setIsSubmitting(true);
        const localDossierUuidKey = slug + "-dossier_uuid";
        const localDossierAccessTokenKey = slug + "-dossier_access_token";
        const uuid = localStorage.getItem(localDossierUuidKey) + "";
        const accessToken =
            localStorage.getItem(localDossierAccessTokenKey) + "";

        dispatch(setGeneralStep(GeneralStepsEnum.Insurance));
        dispatch(unsetAppointment());
        dispatch(setGeneralStep(GeneralStepsEnum.Appointment));

        dispatch(
            postMissingContractorName({
                name: missingContractorName,
                uuid,
                accessToken,
                dossierId: dossier?.dossier_id ?? 0,
            }),
        ).then(() => {
            dispatch(setPostMissingContractor(true));
            dispatch(setGeneralStep(GeneralStepsEnum.Appointment));
            setIsSubmitting(false);
        });
    };

    return (
        <div className="s-appointment__group border-color-primary">
            <h1 className="s-appointment__group__title">
                Missende verzekeringsmaatschappij
            </h1>
            <div className="c-form__group c-form__group--row">
                <input
                    type="text"
                    value={missingContractorName}
                    onChange={handleMissingContractorNameChange}
                    placeholder="Naam maatschappij"
                />
            </div>
            <div className="c-form__group c-form__group--row">
                <button
                    type="button"
                    onClick={handleMissingContractorSubmit}
                    className="c-form__buttons__single--full-width c-form__buttons__single border-color-primary border-color-primary-hover"
                >
                    <span className="font-face-primary">Ga verder</span>
                </button>
            </div>
        </div>
    );
};
